import Vue from 'vue'
import HomePage from '@/views/pages/home'
import LoginPage from '@/views/pages/Login'
import Router from 'vue-router'

import user from './store'

Vue.use(Router)


const router = new Router({
mode: 'history',
base: process.env.BASE_URL,
routes: [
{
path: '/',
name: 'HomePage',
component: HomePage,
meta: { onlyAuthUser: true },
},
{
path: '/login',
name: 'loginPage',
component: LoginPage,
},
],
})

	 // next is a callback function to catch auth-user to go login or register page 
	 //                and non auth-user to go profile-page
	 //                     ~ (Protected page) ~
router.beforeEach((to , from , next) => {


	var l = user

	if (to.meta.onlyAuthUser) {
			if (user.state.user){
				next()
			}else{
				//TODO Navigate to page for non authentecated users
				next({name:'loginPage'})
			}
	}else{
		next()
	}


})



export default router